import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=6c19338d&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c19338d')) {
      api.createRecord('6c19338d', component.options)
    } else {
      api.reload('6c19338d', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=6c19338d&", function () {
      api.rerender('6c19338d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2z5TIyS6XHmfv/JS/starrating.vue"
export default component.exports